import { render, staticRenderFns } from "./Season.vue?vue&type=template&id=67ee5dfc&scoped=true&"
import script from "./Season.vue?vue&type=script&lang=js&"
export * from "./Season.vue?vue&type=script&lang=js&"
import style0 from "./Season.vue?vue&type=style&index=0&id=67ee5dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ee5dfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
